import {
  Measurement,
  measurementOptionsList,
  MeasurementType,
  MeasurementTypeDisplayedNames,
  ReactSelectOption,
  skillAreaDisplayedNames,
} from "../../../../../store/onboarding/types";
import React, { Component } from "react";
import ColumnHeaderSelector from "./ColumnHeaderSelector";
import Button from "react-bootstrap/Button";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import ReadingSkillSelector from "../evidence-tab/ReadingSkillSelector";
import { SkillFocusArea } from "../../../../../store/groups/types";

type Props = {
  index: number;
  measurement: Measurement;
  onMeasureChange: (
    index: number,
    select?: boolean,
    unique_id?: number
  ) => (event: React.SyntheticEvent) => void;
  onPossibleValuesChange: (measurement: Measurement) => (index: number) => any;
  columnNames: Array<string>;
  selectedColumnNames: Array<string>;
  onClick: (event: React.SyntheticEvent) => void;
  onMeasurementRemove: (measurement: Measurement) => any;
  withReadingAlgorithm?: boolean;
  skill_areas?: ReactSelectOption<string>[];
  onSkillAreaChange: (
    index: number,
    skill: string
  ) => any;
  useGradeSpecificColor?: boolean;
  enterDataManuallyType?: "academic" | "behavior";
};

class ColorCriteriaRow extends Component<Props> {
  createRangeTd = (measurement: Measurement, index: number) => {
    switch (measurement.type) {
      case MeasurementType.NUMBER:
        return (
          <div className="form-inline d-flex justify-content-center">
            <div>
              <input
                required
                type="number"
                name="range_min"
                placeholder="Min"
                className="inputSm"
                style={{ minWidth: 50 }}
                value={measurement.range_min}
                onChange={this.props.onMeasureChange(index, false, measurement.unique_id)}
              />
            </div>
            <strong>&nbsp;-&nbsp;</strong>
            <div>
              <input
                required
                type="number"
                name="range_max"
                placeholder="Max"
                className="inputSm"
                style={{ minWidth: 50 }}
                value={measurement.range_max}
                onChange={this.props.onMeasureChange(index, false, measurement.unique_id)}
              />
            </div>
          </div>
        );
      case MeasurementType.PERCENTAGE:
        return <div className="rangeDiv"> 0 - 100 </div>;
      case MeasurementType.CATEGORY:
      default:
        return (
          <Button
            variant="primary"
            size="sm"
            //disabled={!measurement.column_name}
            disabled={this.props.useGradeSpecificColor}
            onClick={this.props.onPossibleValuesChange(measurement)(index)}
          >
            <div className="rangeDiv" style={{ cursor: "pointer" }}>
              Select
            </div>
          </Button>
        );
    }
  };

  render() {
    const { index, measurement } = this.props;
    const buttonDisabled = !(
      measurement.display_name &&
      measurement.column_name &&
      measurement.type !== undefined &&
      ((measurement.range_min !== undefined &&
        measurement.range_max !== undefined) ||
        (measurement.possible_values &&
          measurement.possible_values.length > 0)) &&
      !(measurement.skill_area !== undefined)
    );
    return (
      <tr key={index}>
        {/* <td>{index + 1}</td> */}
        <td>
          <ColumnHeaderSelector
            required
            name={"column_name"}
            value={measurement.column_name!}
            onChange={this.props.onMeasureChange(index, true, measurement.unique_id)}
            columnNames={this.props.columnNames}
            selectedColumnNames={this.props.selectedColumnNames}
          />
        </td>
        <td>
          <input
            required
            name={"display_name"}
            value={measurement.display_name}
            type="text"
            className="stdInput"
            id="displayedName"
            onChange={this.props.onMeasureChange(index, false, measurement.unique_id)}
          />
        </td>
        {/* <td>
          <Form.Control
            required
            name="type"
            as="select"
            value={(measurement.type as unknown) as string}
            onChange={this.props.onMeasureChange(index)}
          >
            {measurementOptionsList.map((measureType: string, index) => (
              <option value={+measureType} key={index}>
                {
                  MeasurementTypeDisplayedNames[
                    (measureType as unknown) as MeasurementType
                  ]
                }
              </option>
            ))}
          </Form.Control>
        </td> */}
        {this.props.withReadingAlgorithm && this.props.enterDataManuallyType === "academic" ? (
          <td>
            <ReadingSkillSelector
              value={measurement.reading_skill}
              skills={this.props.skill_areas!}
              onChange={(skill) =>this.props.onSkillAreaChange(index, skill!)}
            />
          </td>
        ) : null}
        <td>{this.createRangeTd(measurement, index)}</td>
        <td>
          {measurement.color_criteria
            ?.some((c) =>
              c.range_min != undefined
              && c.range_max != undefined
            ) ? (
              <OverlayTrigger
                trigger={"hover"}
                placement="top"
                overlay={
                  <Tooltip className="customTooltip" id="tooltip-top-display">
                    Changing the score range will reset the color criteria.
                  </Tooltip>
                }
              >
              <Button
                variant="link"
                size="sm"
                disabled={buttonDisabled}
                onClick={this.props.onClick}
                className="blueLink"
                // style={{ color: "#007bff" }} // override default link color
              >
                {measurement.color_criteria?.some((criteria) => criteria.range_min !== undefined && criteria.range_max !== undefined) ? 'Edit' : 'Add'}
              </Button>
            </OverlayTrigger>
            ) : (
              <Button
                variant="link"
                size="sm"
                disabled={buttonDisabled}
                onClick={this.props.onClick}
                className="blueLink"
                // style={{ color: "#007bff" }} // override default link color
              >
                {measurement.color_criteria?.some((criteria) => criteria.range_min !== undefined && criteria.range_max !== undefined) ? 'Edit' : 'Add'}
              </Button>
            )}
        </td>
        <td>
          {index > 0 ? <Button onClick={this.props.onMeasurementRemove(measurement)}>
            <FontAwesomeIcon
              icon={faTimesCircle}
              size="lg"
              className="pointer"
              style={{color: 'red'}}
            />
          </Button> : ''}
        </td>
      </tr>
    );
  }
}

export default ColorCriteriaRow;
